import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEntityResource } from '../../core/abstractions/base-entity.resource';
import { Tools } from '../../core/utils/tools';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { UrlParameterModel } from '../../models/core/url-parameter.model';
import { FormattedAddressRequestModel } from '../../models/formatted-address-request.model';
import { LocationModel } from '../../models/location.model';

@Injectable({
    providedIn: 'root'
})
export class LocationsResource extends BaseEntityResource<LocationModel> {
    constructor() {
        super(new ResourceConfig({ baseController: 'locations' }));
    }

    /**
     * Returns a model containing all metadata for the selected tenant.
     */
    getAll(countryId?: string, city?: string, zipCode?: string): Observable<ApiResponseModel<LocationModel[]>> {
        const urlParams: UrlParameterModel[] = [];

        if (!!countryId) {
            urlParams.push(new UrlParameterModel({ key: 'request.countryId', value: countryId }));
        }

        if (!!city) {
            urlParams.push(new UrlParameterModel({ key: 'request.city', value: city }));
        }

        if (!!zipCode) {
            urlParams.push(new UrlParameterModel({ key: 'request.zipCode', value: zipCode }));
        }

        return this._requestService.makeGet<ApiResponseModel<LocationModel[]>>(
            this.getUrl(''),
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            ...urlParams
        );
    }

    /**
     * Obtains a formatted address for a specific location.
     */
    getFormattedAddress(locationId: number, request?: FormattedAddressRequestModel): Observable<ApiResponseModel<string>> {
        const params = request ? Tools.Url.transformToUrlParameterModel(request, true, 'request.') : [];

        return this._requestService.makeGet<ApiResponseModel<string>>(
            this.getUrl(`${locationId}/formatted-address`),
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            ...params
        );
    }
}
